import React from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {getAuthLog} from '../core/_requests'
import {getColumns} from './columns/_columns'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
//import {Overview} from './components/Overview'
import {useIntl} from 'react-intl'

const ListWrapper = () => {
  const intl = useIntl()

  const Breadcrumbs = BreadcrumbsBuilder([{
    title: `${intl.formatMessage({id: 'CORE.HOME.BREADCRUMBS'})}`,
    path: '/'
  }, {
    title: `${intl.formatMessage({id: 'CORE.USERS.LIST.BREADCRUMBS'})}`,
      path: '/app/users/list',
  }])

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>
        {intl.formatMessage({id: 'CORE.USERS.ACTIVITY.PAGE_TITLE'})}
      </PageTitle>
      <TableWrapper
        dataProvider={getAuthLog}
        cols={getColumns(intl)}
        queryId="P2C_CUSTOMER_AUTH_LIST"
        lookup={{placeholder: `${intl.formatMessage({id: 'CORE.USERS.ACTIVITY.LOOKUP_PLACEHOLDER'})}`}}
      />
    </>
  )
}

export default ListWrapper
